import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import injectSheet from 'react-jss';

import { cdn } from '../../helpers/cdn';

const types = {
	onClick: propTypes.func.isRequired,
	isPlaying: propTypes.bool.isRequired
}

const emoteBarAction = (props) => {
	const { onClick, isPlaying, classes } = props;
	const icon = isPlaying ? 'icons/pause-btn.svg' : 'icons/play-btn.svg'

	const classList = classNames({
		[classes.wrapper]: true,
		isPlaying,
		isPaused: !isPlaying
	})

	return (
		<div className={classList} onClick={onClick}>
			<img src={cdn(icon)} />
		</div>
	)
};

const styles = theme => ({
	wrapper: {
		position: 'absolute',
		top: 0,
		right: 0,
		transform: 'translate(50%, -50%)',
		cursor: 'pointer'
	}
});

emoteBarAction.propTypes = types;

export default injectSheet(styles)(emoteBarAction);


// WEBPACK FOOTER //
// ./src/app/components/emotesBar/emoteBarAction.js